// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';
import {Survey_choicegroup} from './survey_choicegroup';
import {Survey_comment} from './survey_comment';
import {Survey_rating} from './survey_rating';
import styles from './survey.module.less';

interface i_survey_page_props extends i_survey_page {
    active: boolean;
    save: t_survey_save;
}
export const Survey_page = (props: i_survey_page_props)=>{
    const {theme} = useContext(Settings_context);
    const {title, subtitle, questions, active, save} = props;
    const cls = cn(styles.survey_page, {[styles.hidden]: !active});
    return <div className={cls}>
      {(title || subtitle) && <div className={styles.text}>
        {title && <p className={theme.bold}>{title}</p>}
        {subtitle && <p className={theme.p2}>{subtitle}</p>}
      </div>}
      {questions.map(q=>{
          if (q.type=='choicegroup')
              return <Survey_choicegroup key={q.id} {...q} save={save}/>;
          if (q.type=='comment')
              return <Survey_comment key={q.id} {...q} save={save}/>;
          if (q.type=='rating')
              return <Survey_rating key={q.id} {...q} save={save}/>;
          return null;
      })}
    </div>;
};
